<template>
  <div class="home-page">
    <!-- ===== HERO SECTION ===== -->
    <section class="hero section--dark">
      <div class="hero__bg-shapes">
        <div class="hero__shape hero__shape--1"></div>
        <div class="hero__shape hero__shape--2"></div>
      </div>
      <div class="section-container">
        <div class="hero__grid">
          <div class="hero__content">
            <span class="badge-label badge-label--light">
              <span class="badge-label__dot"></span>
              Solusi IT Terdepan
            </span>
            <h1 class="hero__title">Pusat Solusi IT untuk <span class="hero__highlight">Bisnis Anda</span></h1>
            <p class="hero__subtitle">Kami menyediakan solusi digital inovatif untuk meningkatkan efisiensi dan kinerja
              bisnis Anda. Dari pengembangan web hingga integrasi cloud.</p>
            <div class="hero__actions">
              <router-link to="/services" class="btn-primary-custom custom-link">Lihat Layanan Kami</router-link>
              <router-link to="/about" class="btn-outline-light custom-link">Pelajari Lebih Lanjut</router-link>
            </div>
            <div class="hero__stats-row">
              <div class="hero__stat">
                <strong>5+</strong>
                <span>Klien Puas</span>
              </div>
              <div class="hero__stat-divider"></div>
              <div class="hero__stat">
                <strong>10+</strong>
                <span>Proyek Selesai</span>
              </div>
              <div class="hero__stat-divider"></div>
              <div class="hero__stat">
                <strong>5+</strong>
                <span>Tahun Pengalaman</span>
              </div>
            </div>
          </div>
          <div class="hero__image-wrap">
            <div class="hero__image-card">
              <img :src="heroImage" alt="Miraverse Team" class="hero__image" />
            </div>
            <div class="hero__floating-card hero__floating-card--1">
              <div class="hero__floating-icon"><i class="fa fa-check-circle"></i></div>
              <div>
                <strong>Inovatif</strong>
                <span>Berpikir Maju, Bertindak Strategis</span>
              </div>
            </div>
            <div class="hero__floating-card hero__floating-card--2">
              <div class="hero__floating-icon hero__floating-icon--alt"><i class="fa fa-star"></i></div>
              <div>
                <strong>Professional</strong>
                <span>Standar Tinggi untuk Solusi Masa Depan</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== ABOUT SECTION ===== -->
    <section class="about section">
      <div class="section-container">
        <div class="about__grid animate-on-scroll">
          <div class="about__image-side">
            <div class="about__image-wrapper">
              <img :src="aboutImage" alt="Digital Transformation" class="about__image" />
              <!-- <div class="about__video-play" @click="openVideo">
                <i class="fa fa-play"></i>
              </div> -->
            </div>
            <div class="about__experience-badge">
              <span class="about__exp-number">5+</span>
              <span class="about__exp-text">Tahun<br />Pengalaman</span>
            </div>
          </div>
          <div class="about__content">
            <span class="badge-label">
              <span class="badge-label__dot"></span>
              Tentang Kami
            </span>
            <h2>Selamat Datang di <span class="text-gradient">Miraverse.ID</span></h2>
            <p class="about__lead">Partner terpercaya Anda dalam dunia digital. Kami adalah tim profesional yang
              berkomitmen untuk menghadirkan solusi teknologi yang inovatif dan efektif.</p>
            <p>Visi kami adalah memudahkan bisnis dalam bertransformasi ke era digital. Kami percaya bahwa setiap
              perusahaan, besar atau kecil, berhak mendapatkan alat dan teknologi yang tepat untuk berkembang dan
              bersaing di pasar global.</p>
            <div class="about__features">
              <div class="about__feature">
                <div class="about__feature-icon"><i class="fa fa-lightbulb-o"></i></div>
                <div>
                  <strong>Solusi Inovatif</strong>
                  <span>Teknologi terkini untuk bisnis Anda</span>
                </div>
              </div>
              <div class="about__feature">
                <div class="about__feature-icon"><i class="fa fa-users"></i></div>
                <div>
                  <strong>Tim Berpengalaman</strong>
                  <span>Profesional di bidangnya</span>
                </div>
              </div>
            </div>
            <router-link to="/about" class="btn-primary-custom custom-link"
              style="margin-top: 16px;">Selengkapnya</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== SERVICES SECTION ===== -->
    <section class="services section section--alt">
      <div class="section-container">
        <div class="section-title animate-on-scroll">
          <span class="badge-label">
            <span class="badge-label__dot"></span>
            Layanan Kami
          </span>
          <h2>Berbagai Solusi IT untuk <span class="text-gradient">Transformasi Digital</span></h2>
          <p class="section-subtitle">Kami menawarkan layanan lengkap untuk mendukung pertumbuhan bisnis Anda.</p>
        </div>
        <div class="services__grid">
          <div v-for="(service, index) in services" :key="service.title" class="card-bexon animate-on-scroll"
            :class="'delay-' + ((index > 2 ? index - 3 : index) + 1)">
            <div class="card-bexon__icon">
              <i :class="service.icon"></i>
            </div>
            <h4 class="card-bexon__title">{{ service.title }}</h4>
            <p class="card-bexon__text">{{ service.short }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== PROJECTS SECTION ===== -->
    <section class="projects section">
      <div class="section-container">
        <div class="section-title animate-on-scroll">
          <span class="badge-label">
            <span class="badge-label__dot"></span>
            Proyek Kami
          </span>
          <h2>Portfolio <span class="text-gradient">Terbaru</span></h2>
          <p class="section-subtitle">Lihat beberapa proyek yang telah kami kerjakan untuk klien kami.</p>
        </div>
        <div class="projects__grid">
          <div v-for="(project, index) in projects" :key="project.name" class="projects__card animate-on-scroll"
            :class="'delay-' + (index + 1)">
            <div class="projects__card-image">
              <img :src="project.image" :alt="project.name" />
              <div class="projects__card-overlay">
                <span class="projects__card-category">{{ project.category }}</span>
              </div>
            </div>
            <div class="projects__card-content">
              <h4>{{ project.name }}</h4>
              <p>{{ project.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== COUNTER STATS BAR ===== -->
    <section class="counter-bar section--gradient">
      <div class="section-container">
        <div class="counter-bar__grid animate-on-scroll">
          <div class="counter-bar__item" v-for="stat in stats" :key="stat.label">
            <span class="counter-value">{{ stat.value }}</span>
            <span class="counter-bar__label">{{ stat.label }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== WHY CHOOSE US / FEATURES ===== -->
    <section class="why-us section">
      <div class="section-container">
        <div class="why-us__grid animate-on-scroll">
          <div class="why-us__content">
            <span class="badge-label">
              <span class="badge-label__dot"></span>
              Mengapa Kami?
            </span>
            <h2>Mengapa Memilih <span class="text-gradient">Miraverse.ID?</span></h2>
            <p>Kami memahami bahwa setiap bisnis memiliki tantangan unik. Oleh karena itu, kami menawarkan solusi yang
              disesuaikan untuk memenuhi kebutuhan spesifik Anda.</p>
            <ul class="why-us__list">
              <li><i class="fa fa-check-circle"></i> Solusi yang disesuaikan dengan kebutuhan bisnis Anda</li>
              <li><i class="fa fa-check-circle"></i> Tim yang berpengalaman dan responsif</li>
              <li><i class="fa fa-check-circle"></i> Teknologi terbaru dan inovatif</li>
              <li><i class="fa fa-check-circle"></i> Dukungan pelanggan 24/7</li>
              <li><i class="fa fa-check-circle"></i> Harga kompetitif dan transparan</li>
            </ul>
          </div>
          <div class="why-us__cards">
            <div class="why-us__card">
              <div class="why-us__card-number">01</div>
              <h4>Konsultasi Gratis</h4>
              <p>Diskusikan kebutuhan digital Anda dengan ahli kami tanpa biaya.</p>
            </div>
            <div class="why-us__card why-us__card--featured">
              <div class="why-us__card-number">02</div>
              <h4>Pengerjaan Cepat</h4>
              <p>Kami berkomitmen menyelesaikan proyek tepat waktu dengan kualitas terbaik.</p>
            </div>
            <div class="why-us__card">
              <div class="why-us__card-number">03</div>
              <h4>Dukungan Penuh</h4>
              <p>Maintenance dan dukungan teknis berkelanjutan setelah proyek selesai.</p>
            </div>
            <div class="why-us__card">
              <div class="why-us__card-number">04</div>
              <h4>Skalabilitas</h4>
              <p>Solusi yang dirancang untuk berkembang seiring pertumbuhan bisnis Anda.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== FAQ SECTION ===== -->
    <section class="faq section section--alt">
      <div class="section-container">
        <div class="faq__grid animate-on-scroll">
          <div class="faq__header">
            <span class="badge-label">
              <span class="badge-label__dot"></span>
              FAQ
            </span>
            <h2>Pertanyaan yang Sering <span class="text-gradient">Diajukan</span></h2>
            <p>Temukan jawaban untuk pertanyaan umum tentang layanan dan proses kerja kami.</p>
          </div>
          <div class="faq__list">
            <div v-for="(faq, index) in faqs" :key="index" class="accordion-item-custom"
              :class="{ 'active': activeFaq === index }">
              <div class="accordion-header-custom" @click="toggleFaq(index)">
                <span>{{ faq.question }}</span>
                <span class="accordion-icon">+</span>
              </div>
              <div class="accordion-body-custom">
                <p>{{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== CTA SECTION ===== -->
    <section class="cta section--dark">
      <div class="cta__bg-shapes">
        <div class="cta__shape cta__shape--1"></div>
        <div class="cta__shape cta__shape--2"></div>
      </div>
      <div class="section-container">
        <div class="cta__content animate-on-scroll">
          <span class="badge-label badge-label--light">
            <span class="badge-label__dot"></span>
            Mulai Sekarang
          </span>
          <h2>Mari Wujudkan Visi Digital Anda Bersama <span style="color: #C73468;">Miraverse.ID</span></h2>
          <p>Hubungi kami hari ini untuk mendiskusikan bagaimana kami dapat membantu bisnis Anda tumbuh dan sukses dalam
            dunia digital yang terus berkembang.</p>
          <div class="cta__actions">
            <router-link to="/contact" class="btn-primary-custom custom-link">Hubungi Kami Sekarang</router-link>
            <a href="https://wa.me/628114938580" class="btn-outline-light custom-link">
              <i class="fa fa-whatsapp"></i> +62 8114938580
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== VIDEO MODAL ===== -->
    <div class="video-modal" :class="{ 'video-modal--open': showVideo }" @click.self="closeVideo">
      <div class="video-modal__content" v-if="showVideo">
        <button class="video-modal__close" @click="closeVideo">&times;</button>
        <div class="video-modal__placeholder">
          <i class="fa fa-play-circle"></i>
          <p>Video Company Profile</p>
          <span>Coming Soon</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiraversePage',
  data() {
    return {
      heroImage: require('@/assets/images/hero-image.png'),
      aboutImage: require('@/assets/images/about-image.png'),
      showVideo: false,
      activeFaq: 0,
      services: [
        {
          icon: 'fa fa-globe',
          title: 'Pengembangan Company Website',
          short: 'Website profesional yang menarik untuk meningkatkan visibilitas dan kredibilitas bisnis Anda.'
        },
        {
          icon: 'fa fa-mobile',
          title: 'Aplikasi Web & Mobile',
          short: 'Aplikasi inovatif untuk semua platform, dari konsep hingga peluncuran yang user-friendly.'
        },
        {
          icon: 'fa fa-cogs',
          title: 'Pengembangan Sistem ERP',
          short: 'Sistem ERP untuk menyederhanakan proses dan meningkatkan efisiensi operasional bisnis.'
        },
        {
          icon: 'fa fa-handshake-o',
          title: 'Pengembangan Sistem CRM',
          short: 'Kembangkan hubungan pelanggan yang lebih kuat dengan wawasan mendalam.'
        },
        {
          icon: 'fa fa-whatsapp',
          title: 'WhatsApp Business Platform',
          short: 'Notifikasi WhatsApp tepat waktu untuk komunikasi langsung dengan audiens Anda.'
        },
        {
          icon: 'fa fa-cloud',
          title: 'Cloud & Domain Provider',
          short: 'Layanan cloud dan domain yang fleksibel, aman, dan dapat diandalkan.'
        }
      ],
      projects: [
        {
          name: 'Sistem Informasi Sekolah',
          description: 'Aplikasi mobile manajemen sekolah terintegrasi dengan modul keuangan, absensi, penilaian, dan agenda siswa.',
          category: 'Mobile App',
          image: require('@/assets/images/project-school-app.png')
        },
        {
          name: 'Sistem Informasi Dana Pensiun',
          description: 'Platform manajemen investasi dana pensiun dengan fitur pengelolaan investasi, keuangan, dan pelaporan transaksi. Dilengkapi dashboard analitik dan audit trail.',
          category: 'Web Application',
          image: require('@/assets/images/project-pension-fund.png')
        },
        {
          name: 'Core Banking System',
          description: 'Sistem perbankan inti dengan dashboard monitoring dana masuk, analitik sumber dana, pengelolaan kas, dan pelaporan keuangan komprehensif.',
          category: 'Web Application',
          image: require('@/assets/images/project-core-banking.png')
        },
      ],
      stats: [
        { value: '100%', label: 'Proyek Berhasil' },
        { value: '5+', label: 'Klien Puas' },
        { value: '10+', label: 'Proyek Selesai' },
        { value: '24/7', label: 'Dukungan Teknis' }
      ],
      faqs: [
        {
          question: 'Berapa lama waktu pengerjaan proyek website?',
          answer: 'Waktu pengerjaan bervariasi tergantung kompleksitas proyek. Untuk website standar, biasanya membutuhkan 2-4 minggu. Untuk aplikasi yang lebih kompleks, bisa memakan waktu 1-12 bulan. Kami akan memberikan estimasi waktu yang jelas di awal proyek.'
        },
        {
          question: 'Apakah tersedia layanan maintenance setelah proyek selesai?',
          answer: 'Ya, kami menyediakan layanan maintenance dan dukungan teknis berkelanjutan. Kami menawarkan paket maintenance bulanan yang mencakup pembaruan keamanan, perbaikan bug, dan dukungan teknis via WhatsApp dan email.'
        },
        {
          question: 'Teknologi apa yang digunakan untuk pengembangan?',
          answer: 'Kami menggunakan teknologi terkini seperti Vue.js dan Flutter untuk frontend, serta .NET, Laravel, Nest.js untuk backend. Dalam pengelolaan database, kami menggunakan MySQL, PostgreSQL, MS SQL Server, hingga MongoDB dan ClickHouse untuk analitik. Untuk infrastruktur, kami bekerja dengan AWS, Google Cloud, BiznetGIO, dan penyedia layanan cloud terpercaya lainnya.'
        },
        {
          question: 'Bagaimana proses kerja sama dimulai?',
          answer: 'Prosesnya dimulai dengan konsultasi gratis untuk memahami kebutuhan Anda. Setelah itu, kami akan membuat proposal lengkap mencakup scope pekerjaan, timeline, dan biaya. Setelah disetujui, kami langsung memulai tahap pengembangan.'
        },
        {
          question: 'Apakah bisa request custom fitur tambahan?',
          answer: 'Tentu saja! Kami selalu terbuka untuk menyesuaikan solusi sesuai kebutuhan unik bisnis Anda. Tim kami akan mendiskusikan fitur tambahan yang diinginkan dan memberikan estimasi biaya dan waktu tambahan yang diperlukan.'
        }
      ]
    }
  },
  mounted() {
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('animated')
            }
          })
        },
        { threshold: 0.1 }
      )
      this.$nextTick(() => {
        document.querySelectorAll('.animate-on-scroll').forEach(el => {
          observer.observe(el)
        })
      })
    },
    toggleFaq(index) {
      this.activeFaq = this.activeFaq === index ? -1 : index
    },
    openVideo() {
      this.showVideo = true
      document.body.style.overflow = 'hidden'
    },
    closeVideo() {
      this.showVideo = false
      document.body.style.overflow = ''
    }
  }
}
</script>

<style scoped lang="scss">
// ===== TEXT GRADIENT =====
.text-gradient {
  background: linear-gradient(135deg, #6C2973, #C73468);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

// ===== HERO =====
.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 120px 0 80px;
  position: relative;
  overflow: hidden;
}

.hero__bg-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.hero__shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
}

.hero__shape--1 {
  top: -20%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: rgba(108, 41, 115, 0.2);
}

.hero__shape--2 {
  bottom: -30%;
  left: -15%;
  width: 500px;
  height: 500px;
  background: rgba(199, 52, 104, 0.12);
}

.hero__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.hero__content {
  position: relative;
  z-index: 2;
}

.hero__title {
  font-size: 3.4rem;
  font-weight: 800;
  color: #fff;
  line-height: 1.15;
  margin-bottom: 20px;
}

.hero__highlight {
  background: linear-gradient(135deg, #C73468, #D44B7A);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero__subtitle {
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.8;
  margin-bottom: 32px;
  max-width: 500px;
}

.hero__actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 48px;
}

.btn-outline-light {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    border-color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.05);
    color: #fff;
  }
}

.hero__stats-row {
  display: flex;
  align-items: center;
  gap: 32px;
}

.hero__stat {
  display: flex;
  flex-direction: column;

  strong {
    font-size: 1.8rem;
    font-weight: 800;
    color: #fff;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  span {
    font-size: 0.82rem;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 2px;
  }
}

.hero__stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.15);
}

// Hero Image
.hero__image-wrap {
  position: relative;
  z-index: 2;
}

.hero__image-card {
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  position: relative;
}

.hero__image {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block;
}

.hero__floating-card {
  position: absolute;
  background: rgba(26, 10, 46, 0.9);
  backdrop-filter: blur(12px);
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  animation: float 4s ease-in-out infinite;

  strong {
    display: block;
    color: #fff;
    font-size: 0.85rem;
  }

  span {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.75rem;
  }
}

.hero__floating-card--1 {
  bottom: 80px;
  left: -30px;
}

.hero__floating-card--2 {
  top: 40px;
  right: -20px;
  animation-delay: 2s;
}

.hero__floating-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #6C2973, #C73468);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
}

.hero__floating-icon--alt {
  background: linear-gradient(135deg, #C73468, #D44B7A);
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

// ===== ABOUT =====
.about__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.about__image-side {
  position: relative;
}

.about__image-wrapper {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 12px 40px rgba(108, 41, 115, 0.12);
}

.about__image {
  width: 100%;
  height: 420px;
  object-fit: cover;
  display: block;
}

.about__video-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6C2973, #C73468);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.4rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 0 0 12px rgba(199, 52, 104, 0.2);

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
    box-shadow: 0 0 0 18px rgba(199, 52, 104, 0.15);
  }

  i {
    margin-left: 3px;
  }
}

.about__experience-badge {
  position: absolute;
  bottom: -20px;
  right: -20px;
  background: linear-gradient(135deg, #6C2973, #C73468);
  border-radius: 16px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 8px 30px rgba(199, 52, 104, 0.3);
}

.about__exp-number {
  font-size: 2.2rem;
  font-weight: 800;
  color: #fff;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.about__exp-text {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.3;
  font-weight: 500;
}

.about__lead {
  font-size: 1.05rem;
  color: $text-body;
  margin-bottom: 16px;
  font-weight: 500;
}

.about__features {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
}

.about__feature {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  background: rgba(108, 41, 115, 0.04);
  border-radius: 12px;
  border: 1px solid rgba(108, 41, 115, 0.08);

  strong {
    display: block;
    font-size: 0.95rem;
    color: $text-dark;
  }

  span {
    font-size: 0.82rem;
    color: $text-muted;
  }
}

.about__feature-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: linear-gradient(135deg, #6C2973, #C73468);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
  flex-shrink: 0;
}

// ===== SERVICES =====
.services__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

// ===== PROJECTS =====
.projects__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}

.projects__card {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 20px rgba(108, 41, 115, 0.08);
  transition: all 0.35s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 40px rgba(108, 41, 115, 0.15);

    .projects__card-image img {
      transform: scale(1.05);
    }
  }
}

.projects__card-image {
  position: relative;
  overflow: hidden;
  height: 240px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
}

.projects__card-overlay {
  position: absolute;
  top: 16px;
  left: 16px;
}

.projects__card-category {
  background: linear-gradient(135deg, #6C2973, #C73468);
  color: #fff;
  padding: 4px 14px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.projects__card-content {
  padding: 24px;

  h4 {
    font-size: 1.15rem;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.9rem;
    color: $text-body;
    line-height: 1.6;
  }
}

// ===== COUNTER BAR =====
.counter-bar {
  padding: 60px 0;
}

.counter-bar__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  text-align: center;
}

.counter-bar__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.counter-bar__label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

// ===== WHY US =====
.why-us__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.why-us__list {
  list-style: none;
  padding: 0;
  margin: 20px 0 0;

  li {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
    font-size: 0.95rem;
    color: $text-body;

    i {
      color: #C73468;
      font-size: 1rem;
    }
  }
}

.why-us__cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.why-us__card {
  background: #fff;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 4px 20px rgba(108, 41, 115, 0.06);
  border: 1px solid rgba(108, 41, 115, 0.06);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(108, 41, 115, 0.12);
  }

  h4 {
    font-size: 1.05rem;
    margin-bottom: 8px;
    margin-top: 12px;
  }

  p {
    font-size: 0.88rem;
    color: $text-body;
    line-height: 1.6;
  }
}

.why-us__card--featured {
  background: linear-gradient(135deg, #6C2973, #C73468);
  border: none;

  h4,
  p {
    color: #fff;
  }

  .why-us__card-number {
    color: rgba(255, 255, 255, 0.3);
  }
}

.why-us__card-number {
  font-size: 2rem;
  font-weight: 800;
  color: rgba(108, 41, 115, 0.1);
  font-family: 'Plus Jakarta Sans', sans-serif;
  line-height: 1;
}

// ===== FAQ =====
.faq__grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 60px;
  align-items: start;
}

.faq__header {
  position: sticky;
  top: 120px;

  p {
    margin-top: 16px;
    color: $text-body;
  }
}

// ===== CTA =====
.cta {
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.cta__bg-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.cta__shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
}

.cta__shape--1 {
  top: -40%;
  left: -10%;
  width: 400px;
  height: 400px;
  background: rgba(108, 41, 115, 0.2);
}

.cta__shape--2 {
  bottom: -40%;
  right: -10%;
  width: 350px;
  height: 350px;
  background: rgba(199, 52, 104, 0.15);
}

.cta__content {
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  h2 {
    color: #fff;
    margin-bottom: 16px;
  }

  p {
    color: rgba(255, 255, 255, 0.65);
    margin-bottom: 32px;
  }
}

.cta__actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

// ===== VIDEO MODAL =====
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;

  &--open {
    opacity: 1;
    pointer-events: auto;
  }
}

.video-modal__content {
  background: #1a0a2e;
  border-radius: 20px;
  width: 90%;
  max-width: 700px;
  padding: 60px;
  position: relative;
  text-align: center;
}

.video-modal__close {
  position: absolute;
  top: 16px;
  right: 20px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 2rem;
  cursor: pointer;

  &:hover {
    color: #fff;
  }
}

.video-modal__placeholder {
  color: rgba(255, 255, 255, 0.5);

  i {
    font-size: 4rem;
    color: #C73468;
    margin-bottom: 16px;
    display: block;
  }

  p {
    font-size: 1.2rem;
    color: #fff;
    margin-bottom: 8px;
  }
}

.v-application a.custom-link {
  color: inherit !important;
}

.v-application .about__content a.custom-link {
  color: #fff !important;
}

// ===== RESPONSIVE =====
@media (max-width: 991px) {

  .hero__grid,
  .about__grid,
  .why-us__grid,
  .faq__grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .hero {
    padding: 120px 0 60px;
    min-height: auto;
  }

  .hero__title {
    font-size: 2.4rem;
  }

  .hero__image {
    height: 350px;
  }

  .services__grid {
    grid-template-columns: 1fr 1fr;
  }

  .projects__grid {
    grid-template-columns: 1fr 1fr;
  }

  .counter-bar__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  .faq__header {
    position: static;
  }
}

@media (max-width: 767px) {
  .hero__title {
    font-size: 2rem;
  }

  .hero__stats-row {
    flex-wrap: wrap;
    gap: 20px;
  }

  .hero__stat-divider {
    display: none;
  }

  .services__grid,
  .projects__grid {
    grid-template-columns: 1fr;
  }

  .why-us__cards {
    grid-template-columns: 1fr;
  }

  .counter-bar__grid {
    grid-template-columns: 1fr 1fr;
  }

  .hero__floating-card {
    display: none;
  }

  .about__experience-badge {
    right: 10px;
    bottom: -15px;
  }
}
</style>
